<script setup>
    import RebuildNotification from '@/components/vue-components/RebuildNotification.vue';
    import PublicAlertModal from '@guest/shared/modals/PublicAlertModal.vue';
</script>

<template>
    <teleport to="body">
        <public-alert-modal id="modal-alert-success" type="success" title="Good to go!">
            <div id="modal-alert-success-message" class="mb-4">
                The update was processed successfully.
            </div>
        </public-alert-modal>

        <public-alert-modal id="modal-alert-error" type="danger" title="Oops!">
            <p class="fs-lg text-body-secondary mb-4">We ran into an error.</p>
            <div id="modal-alert-error-message" class="text-start mx-2 mb-4 fst-italic">
                No error message.
            </div>
        </public-alert-modal>

        <public-alert-modal id="modal-alert-warning" type="warning" title="Be careful...">
            <div id="modal-alert-warning-message" class="mb-4">No warning message.</div>
        </public-alert-modal>

        <public-alert-modal id="modal-alert-info" type="info" title="Just FYI">
            <div id="modal-alert-info-message" class="mb-4">No info message.</div>
        </public-alert-modal>

        <rebuild-notification :show="showRebuild" />
    </teleport>
</template>

<script>
    export default {
        data() {
            return {
                showRebuild: false
            };
        },
        watch: {
            '$page.props.version'() {
                this.showRebuild = true;
                setTimeout(() => (this.showRebuild = false), 100);
            }
        }
    };
</script>
